var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"skeleton",style:({
    width: _setup.width,
    height: _setup.height,
    borderRadius: _vm.radius,
    animationDelay: _setup.animationDelay,
  }),attrs:{"data-anima":"bottom"}})
}
var staticRenderFns = []

export { render, staticRenderFns }